import BellIcon from "@heroicons/react/20/solid/BellIcon";
import CloseIcon from "@heroicons/react/20/solid/XMarkIcon";
import EnvelopeIcon from "@heroicons/react/24/outline/EnvelopeIcon";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import InputBase from "@mui/material/InputBase";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const AlertContainer = styling(Box)((props) => ({
  display: "flex",
  background:
    "linear-gradient(275.78deg, rgba(242, 175, 41, 0.16) -51.84%, rgba(242, 125, 41, 0.28) -38.45%, rgba(242, 175, 41, 0.16) -18.6%, rgba(81, 42, 204, 0.24) 31.08%, rgba(53, 25, 141, 0.4) 100%), #FFFFFF",
  boxShadow: `0.25rem 0 0.625rem rgba(0, 0, 0, 0.16)`,
  width: "100%",
  height: "3.5rem",

  alignItems: "center",
  justifyContent: "center",
  gap: "2rem",

  [props.theme.breakpoints.down(768)]: {
    flexDirection: "column",
    height: "5.375rem",
    gap: "0.8rem",
  },
}));

export const BoxStyled = styling(Box)((props) => ({
  display: "flex",
  justifyContent: "center",

  ...(props.typeof === "left" && {
    gap: "1rem",

    [props.theme.breakpoints.down("sm")]: {
      marginRight: "6.25rem",
    },
  }),

  ...(props.typeof === "right" && {
    gap: "0.5rem",
  }),
}));

export const TextStyled = styling(Typography)((props) => ({
  fontSize: "1rem",
  fontWeight: "500",

  [props.theme.breakpoints.down("sm")]: {
    fontSize: "0.8rem",
  },
}));

export const InputBaseStyled = styling(InputBase)((props) => ({
  backgroundColor: Color.white,
  alignItems: "center",
  height: "2.25rem",

  fontSize: "0.875rem",

  border: `0.06rem solid ${Color.black}`,
  borderRadius: "0.3rem",
  padding: "0 1rem",

  "& .MuiInputBase-input": {
    padding: "0",
  },

  [props.theme.breakpoints.down("sm")]: {
    padding: "0 0.375rem",
  },
}));

export const InputAdornmentStyled = styling(InputAdornment)({});

export const ButtonStyled = styling(Button)({
  backgroundColor: Color.black,
  height: "2.25rem",
  borderRadius: "0.3rem",
  textTransform: "none",
});

export const CloseIconStyled = styling(CloseIcon)((props) => ({
  position: "absolute",
  right: "0",
  width: "1.3rem",
  marginRight: "1.3rem",

  "&:hover": {
    cursor: "pointer",
  },

  [props.theme.breakpoints.down("sm")]: {
    left: "50%",
    top: "0",
    margin: "0.6rem 0 0 9.375rem",
  },
}));

export const EnvelopeIconStyled = styling(EnvelopeIcon)({
  width: "1.3rem",
});

export const BellIconStyled = styling(BellIcon)({
  width: "1.3rem",
  marginRight: "1.3rem",
});
